<template>
    <div class="main-panel">
        <SearchOrders></SearchOrders>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { useRoute } from "vue-router";

    import SearchOrders from "../components/SearchOrders.vue";

    export default defineComponent({
        components: {
            SearchOrders
        },
    });
</script>
